import * as React from 'react';
import { Popover } from 'reactstrap';
import HelpSVG from '../svg/HelpSVG';

interface TooltipPopoverState {
	popoverOpen: boolean;
}

/**
 * Tooltip Popover component
 * This component is displayed in the edit form in each field labels, if there is tooltip data available for that field.
 * Clicking in this popover will display the selected tooltip text.
 *
 * @class TooltipPopover
 * @extends {React.Component<any, TooltipPopoverState>}
 */
class TooltipPopover extends React.Component<any, TooltipPopoverState> {
	constructor(props) {
		super(props);

		this.state = {
			popoverOpen: false,
		};
	}

	public toggle = () => {
		this.setState({
			popoverOpen: !this.state.popoverOpen,
		});
	};

	public render() {
		return (
			<div className="tooltip__item">
				<button
					type="button"
					className="tooltip__tooltip-wrapper"
					id={this.props.name + '_tooltip'}
					onClick={this.toggle}
					aria-expanded={this.state.popoverOpen}
				>
					<span className="visually-hidden">Help</span>
					<HelpSVG class={'tooltip__tooltip'} />
				</button>
				<Popover
					placement={this.props.placement}
					isOpen={this.state.popoverOpen}
					target={this.props.name + '_tooltip'}
					toggle={this.toggle}
					disabled={this.props.disabled}
				>
					{this.props.children}
				</Popover>
			</div>
		);
	}
}

export default TooltipPopover;
